define('type/menu/Serum.MainMenu',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'common/module/date/Serum.Clock'
], function($, Pubsub, Clock) {
  'use strict';

  return function(selector) {
    var menu = document.querySelector(selector);
    var open = menu.querySelector('.selected');
    var prev = menu.parentNode.querySelector('.menu__scroller--prev');
    var next = menu.parentNode.querySelector('.menu__scroller--next');
    var move = function(endX){
      var nowX = menu.scrollLeft;
      var anim = function(){
        if(Math.abs(endX - nowX) > 5){
          setTimeout(anim, 16, menu.scrollLeft = Math.round(nowX+= (endX - nowX) / 5));
        }
      };
      anim();
    };

    var scrollerToggle = function(){
      var prevShow = prev.style.opacity = Number(menu.scrollLeft > 5);
      var nextShow = next.style.opacity = Number(menu.scrollWidth - menu.offsetWidth - menu.scrollLeft - 20 > 0);
      prev.style.visibility = prevShow? 'visible' : 'hidden';
      next.style.visibility = nextShow? 'visible' : 'hidden';
    };

    //Move menu view on load
    if(open){
      menu.scrollLeft = Math.round(Math.max(0, open.offsetLeft - (menu.offsetWidth - open.offsetWidth) / 2));
    }

    //Toggle overflow on scroll and resize
    Pubsub.subscribe(Pubsub.topics.DID_RESIZE, scrollerToggle);
    menu.addEventListener('scroll', scrollerToggle);
    setTimeout(scrollerToggle, 0); //Wait to end of JS-event-loop

    //Animate scroll on overflow-click
    prev.addEventListener('click', function(){
      move(menu.scrollLeft - 150);
    });
    next.addEventListener('click', function(){
      move(menu.scrollLeft + 150);
    });

    //Initialie clock
    Clock.initialize($('.menu__time'));
  }
});

